/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Editor_TitleInputs */

const vi_packaging_editor_title = /** @type {(inputs: Packaging_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư bao bì cần dùng`)
};

/**

* @param {Packaging_Editor_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_editor_title = /** @type {((inputs?: Packaging_Editor_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Editor_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_editor_title(inputs)
});